export const CONFIG = {
  API_BASE_URL: import.meta.env.VITE_API_URL || '/api/v1',
  SYNC_INTERVAL_MS: 5 * 60 * 1000, // 5 minutes
  HEARTBEAT_INTERVAL_MS: 60 * 1000, // 1 minute
  MEDIA_CACHE_DIR: 'sensar-media',
  PLAYBACK_TRANSITION_MS: 500,
  DEFAULT_IMAGE_DURATION_MS: 10 * 1000, // 10 seconds for images
  RETRY_BACKOFF_BASE_MS: 1000,
  // Cap the exponential backoff so a flapping server doesn't end up
  // waiting 5+ minutes between attempts. 60s is the sweet spot for
  // signage: long enough to ride out a deploy, short enough that we
  // don't accumulate too many minute-old pending operations.
  RETRY_BACKOFF_CAP_MS: 60_000,
  // ±20% jitter on each backoff delay — when the API in Hetzner comes
  // back after an outage, N TVs in a fleet would otherwise all retry on
  // the same millisecond and thunder the server.
  RETRY_BACKOFF_JITTER: 0.2,
  RETRY_MAX_ATTEMPTS: 5,
  /** Polling interval for the URL-Launcher / web auto-updater. */
  WEB_UPDATE_CHECK_INTERVAL_MS: 60_000,
  SENSOR_POLL_INTERVAL_MS: 500,
  PRESENCE_BATCH_SIZE: 50,
  PROOF_OF_PLAY_BATCH_SIZE: 100,
} as const;
